// leaker.js
'use strict';

export const LEAKER_PREFIX_MESSAGE = 'leaker tired to do somethings';

/**
 *
 * @param {object} options
 * @param {string} options.message
 * @returns {string}
 */
export const leakerMessage = ({ message = '' } = {}) =>
  `${LEAKER_PREFIX_MESSAGE}${message ? ` - ${message}` : ''}`;

export default leakerMessage;
